import React, {useState} from "react";
import ContainerBox from "@/utils/ContainerBox";
import CmsPageTitle from "@/utils/CmsPageTitle";
import { useForm } from "react-hook-form";
import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  Input,
  Box,
  Heading,
  Img,
  FormErrorMessage,
  Textarea
} from "@chakra-ui/react";
import useCustomToast from "hooks/useCustomToast";
import ContactThankyou from "@/components/modal/contact-thankyou";
import { contact } from "store/authSlice";
import { useDispatch } from "react-redux";
const Contact = () => {
  const dispatch=useDispatch();
  const toast = useCustomToast();
  const [isOpenModal, setToggle] = useState(false);
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
    setValue,
    trigger,
    reset
  } = useForm();

  const handlerToReset = async(data) => {
    const resultAction = await dispatch(
      contact({...data,status:false})
    );
    if (contact.fulfilled.match(resultAction)) {
      document.forms["contact-form"].reset();
      reset();
      setToggle(!isOpenModal);
    } else {
      toast((resultAction.payload || 'Failed!'),'error', "", true);
    }
  };
  const handleChange = async (e,label) => {
    setValue(label, e.target.value);
    await trigger(label);
  };
  return (
    <Box>
        <CmsPageTitle title="Contact us" contactEmail="info@skilsoar.com"/>
        <ContainerBox Style="gap-4 sm:gap-8">
          <Flex sx={{alignItems:'center'}}>
              <Box className="container mx-auto">
                <Box>
                  <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                    <Box className="login-page-container login-form-wrapper contact-page-wrapper">
                      <Heading className="heading-color text-center">Get In Touch</Heading>
                      <form name="contact-form" className="mt-6" onSubmit={handleSubmit(handlerToReset)}>
                        <FormControl className="mb-4" isInvalid={errors.name}>
                          <FormLabel className="form-label">Name</FormLabel>
                          <Input
                            className="form-control"
                            type="text"
                            {...register("name", {
                              required: "Name is required"
                            })}
                            placeholder="Enter Name"
                            onChange={(e)=>handleChange(e,'name')}
                          />
                          <FormErrorMessage>
                            {errors.name && errors.name.message}
                          </FormErrorMessage>
                        </FormControl>
                        <FormControl className="mb-4" isInvalid={errors.email}>
                          <FormLabel className="form-label">Email</FormLabel>
                          <Input
                            className="form-control"
                            type="email"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                message: "Invalid email address",
                              },
                            })}
                            placeholder="Enter Email"
                            onChange={(e) => handleChange(e, "email")}
                          />
                          <FormErrorMessage>
                            {errors.email && errors.email.message}
                          </FormErrorMessage>
                        </FormControl>
                        <FormControl className="mb-4" isInvalid={errors.description}>
                          <FormLabel className="form-label">Description</FormLabel>
                          <Textarea rows="4"
                            className="form-control"
                            {...register("description", {
                              required: "Description is required",
                            })}
                            placeholder="Enter Somethings..."
                            onChange={(e) => handleChange(e, "description")}
                          />
                          <FormErrorMessage>
                            {errors.description && errors.description.message}
                          </FormErrorMessage>
                        </FormControl>
                        <Button className="dark-blue-btn mt-4 lg:mb-0 mb-3" type="submit">
                          Submit
                        </Button>
                      </form>
                    </Box>
                    <Box className="login-form-img-wrapper">
                      <Img src="../assets/ContactImage.png" alt="login-img" />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </ContainerBox>
          <ContactThankyou isOpenModal={isOpenModal} setToggle={setToggle}/>
    </Box>
  );
};

export default Contact;
